var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stand-pagination-table-container" },
    [
      _c(
        "vxe-table",
        {
          ref: "vxeTable",
          attrs: {
            data: _vm.data,
            loading: _vm.loading,
            size: _vm.size,
            border: true,
            stripe: true,
            height: _vm.computedTableHeight,
            "virtual-x-config": { enabled: true, gt: 20 },
            "virtual-y-config": { enabled: true, gt: 25 },
            "edit-config": { trigger: "click", mode: "cell", showStatus: true },
            "keep-source": "",
          },
          on: {
            "checkbox-change": _vm.handleCheckboxChange,
            "checkbox-all": _vm.handleCheckboxAllChange,
            "cell-dblclick": _vm.handleCellDblClick,
          },
        },
        [
          _vm.child
            ? _vm._l(_vm.processedColumns, function (item, key) {
                return _c(
                  "vxe-colgroup",
                  {
                    key: item.title,
                    attrs: {
                      title: item.title,
                      width: item.width || 100,
                      fixed: item.fixed,
                      align: item.align || "center",
                    },
                  },
                  _vm._l(item.child, function (column) {
                    return _vm.child
                      ? _c("vxe-column", {
                          key: column.field,
                          attrs: {
                            field: column.field,
                            title: column.title,
                            width: column.width,
                            "edit-render": column.editRender,
                            formatter: column.vxeFormatter,
                            "show-overflow":
                              column.showOverflow === false ? false : "tooltip",
                            fixed: column.fixed,
                          },
                        })
                      : _vm._e()
                  }),
                  1
                )
              })
            : _vm._l(_vm.processedColumns, function (column) {
                return _c("vxe-column", {
                  key: column.field,
                  attrs: {
                    field: column.field,
                    title: column.title,
                    width: column.width,
                    "edit-render": column.editRender,
                    formatter: column.vxeFormatter,
                    "show-overflow":
                      column.showOverflow === false ? false : "tooltip",
                    fixed: column.fixed,
                  },
                })
              }),
        ],
        2
      ),
      _vm.showPage && _vm.paginationConfig.total > 0
        ? _c("vxe-pager", {
            attrs: {
              "current-page": _vm.paginationConfig.currentPage,
              "page-size": _vm.paginationConfig.pageSize,
              total: _vm.paginationConfig.total,
              "page-sizes": _vm.pageSizeOptions,
              layouts: [
                "PrevJump",
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "NextJump",
                "Sizes",
                "FullJump",
                "Total",
              ],
            },
            on: { "page-change": _vm.handlePageChange },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }